module.exports = {
  API_URL: 'https://imapp.intermiles.com/api',
  domain: 'https://www.intermiles.com',
  currentEnv: 'prod',

  //Keycloak configs
  keycloakDomain: 'https://sso.intermiles.com',
  realm: 'InterMiles',
  keycloakCId: 'KenIgi7YNV8uxli3rN8FndCTEmbtkLa3',
};
